module.exports = __webpack_public_path__ + "img/b3a44c8442629d038152cf400f661fbd.0423e916.png";